import { configureStore, ThunkAction, Action, applyMiddleware, } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { History } from 'history';

import { configSlice } from '../features/config/configSlice';
import { authSlice, AuthState, authMiddleware, authPersistConfig } from '../features/auth/authSlice';
import { tenantSlice } from '../features/tenant/tenantSlice';
import { userSlice, userMiddleware, } from '../features/user/userSlice';
import { roleSlice } from '../features/role/roleSlice';
import { memberSlice } from '../features/member/memberSlice';
import { clientSlice } from '../features/client/clientSlice';
import { scopeSlice } from '../features/scope/scopeSlice';
import { roleBindingSlice } from '../features/role-binding/roleBindingSlice';

export function configure(history: History) {
  const routeReducer = connectRouter(history);
  const routeEnhancer = applyMiddleware(routerMiddleware(history));
  const store = configureStore({
    reducer: {
      config: configSlice.reducer,
      auth: persistReducer<AuthState>({ ...authPersistConfig, storage }, authSlice.reducer),
      tenant: tenantSlice.reducer,
      user: userSlice.reducer,
      role: roleSlice.reducer,
      role_binding: roleBindingSlice.reducer,
      member: memberSlice.reducer,
      client: clientSlice.reducer,
      scope: scopeSlice.reducer,
      router: routeReducer,
    },
    middleware: (getDefaultMiddleware) => {
      return getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }).concat(authMiddleware, userMiddleware);
    },
    enhancers: [routeEnhancer],
  });
  const persistor = persistStore(store)
  return { store, persistor };
}


export type store = ReturnType<typeof configure>['store'];
export type AppDispatch = store['dispatch'];
export type RootState = ReturnType<store['getState']>;
export type ThunkAPI = {
  dispatch: AppDispatch;
  getState: () => RootState;
};
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
export type AppThunkConfig = {
  dispatch: AppDispatch;
  state: RootState;
};
